module.exports = __webpack_public_path__ + "img/erp-logos_0000_dear.869ee54a.jpg";